exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.feed .feedItem[data-v-a8dc49b6] {\n  height: auto;\n  display: none;\n}\n.niceRadius[data-v-a8dc49b6] {\n  border-radius: 5000px;\n}\n.temperatureDegrees[data-v-a8dc49b6] {\n  font-size: 2.9rem;\n}\n.windyContainer[data-v-a8dc49b6] {\n  height: 250px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-a8dc49b6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedcardWeather.vue
// module id = 2426
// module chunks = 0